import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $ from 'jquery'
import '@/assets/scss/index.scss'
import '@/assets/css/iconfont.css'

import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

import Print from 'vue-print-nb'
Vue.use(Print);

// http 请求拦截器
import httpRequest from './utils/httpRequest.js'
Vue.prototype.$http = httpRequest;

// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

//引入共同变量
import global from './utils/global_variable'

Vue.prototype.global = global;

import preventReClick from './utils/directive'
Vue.use(preventReClick)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// 自定义金额格式化组件，并全局注册
// import currencyInput from "./views/common/currencyInput/CurrencyInput";
// Vue.use(currencyInput);

import { Loading } from 'element-ui'
Vue.prototype.openLoading = function() {
  const loading = this.$loading({           // 声明一个loading对象
    lock: true,                             // 是否锁屏
    text: '加载中',                         // 加载动画的文字
    spinner: 'el-icon-loading',             // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.3)',       // 背景颜色
    target: '.el-table, .table-flex, .region',       // **需要遮罩的区域，这里写要添加loading的选择器**
    fullscreen: true,
    customClass: 'loadingclass'             // **遮罩层新增类名，如果需要修改loading的样式**
  })
  setTimeout(function () {                  // 设定定时器，超时10S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close();                        // 关闭遮罩层
  },300000)
  return loading;
}

import VueUeditorWrap from 'vue-ueditor-wrap'
Vue.component('vue-ueditor-wrap', VueUeditorWrap)

//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
